import { connect } from 'react-redux';
import React, { Component } from 'react';

import ApiList from './ApiList';


class TreeNavBar extends Component {
  render() {
    return (
      <div style={{position:'absolute', top:'65px', backgroundColor:'white', maxWidth:'337px', height:'calc(100vh - 65px)', overflowY:'scroll', overflowX:'hidden'}}>
        <ApiList/>
      </div>
    );
  }
}

export default TreeNavBar;
